import {Component, ElementRef, Input, OnDestroy, ViewChild} from '@angular/core';
import {ButtonComponent, ButtonType} from '../button/button.component';
import {NgIf} from '@angular/common';
import {MatIconModule} from '@angular/material/icon';
import {ModalService} from "../../../../services/local/modal/modal.service";
import {v4 as uuid} from 'uuid';

@Component({
  selector: 'app-message-modal',
  standalone: true,
  imports: [ButtonComponent, MatIconModule, NgIf],
  templateUrl: './message-modal.component.html',
})
export class MessageModalComponent implements OnDestroy {
  /** Property to store modal ID */
  @Input() id: string = '';

  /** Property to hold modal title */
  @Input() title: string = '';

  /** Property to hold modal subtitle */
  @Input() subTitle: string = '';

  // Property to hold modal icon types
  @Input() modalFace: 'happy' | 'sad' | 'caution' = 'sad';

  /** Property to hold modal message */
  @Input() message: string = '';

  /** Property to hold modal positive button text */
  @Input() positiveButtonText: string = '';

  /** Property to hold modal negative button text */
  @Input() negativeButtonText: string = 'cancel';

  /** Property to hold modal positive button type */
  @Input() positiveButtonType: ButtonType = 'primary';

  /** Property to hold modal negative button type */
  @Input() negativeButtonType: ButtonType = 'secondary';

  /** Property to hold modal close button status */
  @Input() showCloseButton: boolean = true;

  /** Property to handle modal open/close value */
  public isOpen: boolean = false;

  /** Property to handle modal cancelable value */
  public isCancelable: boolean = true;

  /** Property to handle modal positive button click */
  @Input() positiveButtonClick?: () => void;

  /** Property to handle modal negative button click */
  @Input() negativeButtonClick?: () => void;

  /** Modal Subscription */
  private subscription$: any = null;

  @ViewChild('modal', {static: true}) modal!: ElementRef;

  constructor(
    private modalService: ModalService,
  ) {
    // Set Modal ID
    this.id = uuid();

    // Subscribe Alert Toggle From Alert Service
    this.subscription$ = this.modalService.currentConfigSubject.subscribe(
      (value: any) => {
        // Assign values from alert service
        this.isOpen = value.open ?? false;
        this.title = value.title ?? '';
        this.message = value.message ?? '';
        this.positiveButtonText = value.positiveButtonText ?? '';
        this.negativeButtonText = value.negativeButtonText ?? '';
        this.positiveButtonType = value.positiveButtonType ?? 'primary';
        this.negativeButtonText = value.negativeButtonText ?? '';
        this.negativeButtonType = value.negativeButtonType ?? 'load';
        this.positiveButtonClick = value.positiveButtonClick;
        this.negativeButtonClick = value.negativeButtonClick;
        this.isCancelable = value.isCancelable ?? true;
        this.showCloseButton = value.showCloseButton ?? false;
        this.modalFace = value.modalFace ?? 'sad';
      }
    );
  }

  /**
   * Dismiss Message Modal
   */
  dismissModal() {
    this.modalService.dismissModal();
  }

  /**
   * Negative Button Click
   */
  onPositiveButtonClick() {
    this.positiveButtonClick?.();
    this.dismissModal();
  }

  /**
   * Positive Button Click
   */
  onNegativeButtonClick() {
    this.negativeButtonClick?.();
    this.dismissModal();
  }

  /**
   * On Destroy
   */
  ngOnDestroy() {
    if (this.subscription$) {
      this.subscription$.unsubscribe();
    }
  }
}
